'use client';

import ClientErrorRecovery from '@/components/ClientErrorRecovery';

export default function RootError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ClientErrorRecovery boundary="root" error={error} />;
}
